common.View.create('shop::order.Index', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initSelectionActions();
        this.keepDropdownOpen();
    },

    initSelectionActions()
    {
        $('.crud\\:\\:datatable-SelectionActions').find('select')
            .on('change', (event) => {
                this.enableAllSelectionActions();

                // Invoice export?
                if( ['export_invoice', 'create_barcodes'].includes($(event.currentTarget).val()) ) {
                    this.initDatatable($(event.currentTarget).val());
                }
            }).trigger('change');
    },

    enableAllSelectionActions()
    {
        $('.selectionAction').each((key, checkbox) => {
            $(checkbox).attr('disabled', false);
        });
    },

    initDatatable(field)
    {
        if( field === 'export_invoice') {
            this.disableInvoiceExportSelectionActions();
        } else if( field === 'create_barcodes' ) {
            this.disableBarcodeSelectionActions();
        }

        // On table draw compare checkbox values with selectedIds.
        let table = $('#dataTableBuilder').DataTable();
        table.on('draw', () => {
            if( field === 'export_invoice') {
                this.disableInvoiceExportSelectionActions();
            } else if( field === 'create_barcodes' ) {
                this.disableBarcodeSelectionActions();
            }
        });
    },

    disableInvoiceExportSelectionActions()
    {
        // Iterate each selectionAction.
        $('.selectionAction').each((key, checkbox) => {
            // Has invoice nr?
            if( !$(checkbox).parents('.selectionActions').parent().find('.invoice_nr').html() ) {
                // Set disabled since user may not export this once; set checked false; dnd trigger change
                $(checkbox).attr('disabled', true)
                    .prop('checked', false)
                    .trigger('change');
            }
        });
    },

    disableBarcodeSelectionActions()
    {
        // Iterate each selectionAction.
        $('.selectionAction').each((key, checkbox) => {
            // Has invoice nr?
            if( !['sent', 'completed'].includes( $(checkbox).parents('.selectionActions').parent().find('.shop\\:\\:order-StatusBadge').data('value') ) ) {
                // Set disabled since user may not export this once; set checked false; dnd trigger change
                $(checkbox).attr('disabled', true)
                    .prop('checked', false)
                    .trigger('change');
            }
        });
    },

    keepDropdownOpen()
    {
        // Dropdown toggle button
        this.element.find('.dropdown-toggle').click((e) => {
            $(e.currentTarget).parents('.dropdown').find('.dropdown-menu').toggle();

            e.stopPropagation();
        });

        // Dropdown menu click
        this.element.find('.dropdown-menu').click((e) => {
            e.stopPropagation();
        });

        $(window).on('click', (e) => {
            e.stopPropagation();

            // Container
            let container = $('#main-wrapper');

            // Target click is not daterange picker
            if (container.has(e.target).length) {
                this.element.find('.dropdown-menu').hide();
            }
        });
    }

});
